import { TFrequency } from "../../shared/components/features/event-scheduler/interfaces/event.interfaces";

//NOTE: Obtaing from back/sector-workflow/src/common/interfaces/index.interface.ts
export enum EFrequencyType {
  ONE_TIME = "one-time",
  DAILY = "daily",
  WEEKLY = "weekly",
  BY_WEEKLY = "by_weekly", //TODO: ADD THIS FREQUENCY TYPE TO THE DATABASE AND THE SEEDERS
  MONTHLY = "monthly",
  BY_MONTHLY = "by_monthly", //TODO: ADD THIS FREQUENCY TYPE TO THE DATABASE AND THE SEEDERS
  QUARTERLY = "quarterly", //TODO: ADD THIS FREQUENCY TYPE TO THE DATABASE AND THE SEEDERS
  SEMI_ANNUALLY = "semi_annually", //TODO: ADD THIS FREQUENCY TYPE TO THE DATABASE AND THE SEEDERS
  YEARLY = "yearly",
  HOURLY = "hourly",
}

export interface IRecurringFee {
  frequencyType: EFrequencyType;
  freqencyFormatted: string;
}

export const recurringFee = (frequency: TFrequency): IRecurringFee => {
  if (frequency.type === EFrequencyType.DAILY) {
    return { frequencyType: EFrequencyType.DAILY, freqencyFormatted: "Daily" };
  } else if (frequency.type === EFrequencyType.WEEKLY) {
    // Weekly: cada semana (each === 1 o no existe)
    // By Weekly: cada X semanas (each > 1)
    const each = frequency?.each ?? 1;
    if (each > 1) {
      const frequencyType = each === 2 ? EFrequencyType.BY_WEEKLY : EFrequencyType.BY_WEEKLY;
      const freqencyFormatted = each === 2 ? "Bi-Weekly" : `Every ${each} weeks`;
      return { frequencyType, freqencyFormatted };
    }
    return { frequencyType: EFrequencyType.WEEKLY, freqencyFormatted: "Weekly" };
  } else if (frequency.type === EFrequencyType.MONTHLY) {
    // Monthly: cada mes (each === 1 o no existe)
    // By Monthly: cada X meses (each > 1)
    const each = frequency?.each ?? 1;
    if (each > 1) {
      const frequencyType = each === 2 ? EFrequencyType.BY_MONTHLY : EFrequencyType.BY_MONTHLY;
      const freqencyFormatted = each === 2 ? "Bi-Monthly" : `Every ${each} months`;
      return { frequencyType, freqencyFormatted };
    }
    return { frequencyType: EFrequencyType.MONTHLY, freqencyFormatted: "Monthly" };
  } else if (frequency.type === EFrequencyType.YEARLY) {
    return { frequencyType: EFrequencyType.YEARLY, freqencyFormatted: "Yearly" };
  } else if (frequency.type === "hourly") {
    return { frequencyType: EFrequencyType.HOURLY, freqencyFormatted: "Hourly" };
  } else {
    throw new Error("Invalid frequency");
  }
};
